// @vendors
import { create } from 'zustand';

// @types
import { UserInfo, ProfessionalInfo } from '../types/profile.types';

// @services
import profileService from '../services/profile.service';

interface ProfileStoreState {
  user: UserInfo | null;
  professional: ProfessionalInfo | null;
  isLoading: boolean;
  error: string | null;
  getProfessionalInfo: (professionalId: string) => Promise<void>;
  getUserTypeInfo: (userType: string) => Promise<void>;
  getProfessionalTypeInfo: (userType?: string) => Promise<ProfessionalInfo>;
}

const useProfileStore = create<ProfileStoreState>((set, get) => ({
  user: null,
  professional: null,
  isLoading: false,
  error: null,

  getProfessionalInfo: async (professionalId: string) => {
    set({ isLoading: true });
    try {
      const professional = await profileService.fetchProfessionalInfo(professionalId);
      set({ professional, isLoading: false });
    } catch (error) {
      set({ error: 'Error fetching professional info', isLoading: false });
    }
  },

  getUserTypeInfo: async (/* userType: string */) => {
    set({ isLoading: true });
    try {
      await profileService.fetchUserTypeInfo(/* userType */);
      // set({ user, isLoading: false });
    } catch (error: unknown) {
      if (error instanceof Error) {
        set({ error: error.message, isLoading: false });
      } else {
        set({ error: 'An unknown error occurred', isLoading: false });
      }
    }
  },

  getProfessionalTypeInfo: async () => {
    set({ isLoading: true });
    try {
      const professional = await profileService.fetchProfessionalTypeInfo();
      set({ professional, isLoading: false });
      return professional;
    } catch (error: any) {
      set({ error: error.message, isLoading: false });
      throw error;
    }
  },
}));

export default useProfileStore;